import React from 'react'
import styles from './styles.module.scss'

function CTATitle({ title, subTitle }) {
  return (
    <React.Fragment>
      <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
      {subTitle && <h3 className={styles.subtitle}>{subTitle}</h3>}
    </React.Fragment>
  )
}

export default CTATitle
